import React from 'react';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import '../assets/less/_package_indexpage.less';
import InfoBoxes from './InfoBoxes';
import SearchHeader from './SearchHeader';
import actions from './Actions.jsx';
import GeoElementsList from '../geoelements/GeoElementsList';
import '../assets/styles/slick.less';
import 'slick-carousel/slick/slick-theme.less';

export class App extends React.Component {
  static resizeListener(that) {
    return () => that.props.screenResize(App.getViewportWidth());
  }

  static getViewportWidth() {
    if (window.innerWidth !== undefined) {
      return window.innerWidth;
    }

    return Math.max(document.body.clientWidth, document.documentElement.clientWidth);
  }

  static scrollListener(that) {
    return () => that.props.scrollY(window.pageYOffset || document.documentElement.scrollTop);
  }

  componentDidMount() {
    document.body.classList.add('oldHomepage');
    document.getElementById('footer').classList.remove('hide'); // Avoid jumping footer by first hiding & then unhiding

    App.resizeListener(this)();
    window.addEventListener('resize', throttle(App.resizeListener(this), 128));
    window.addEventListener('scroll', throttle(App.scrollListener(this), 128));
  }

  render() {
    const regions = [
      { name: 'Baden-Württemberg', key: ['/orte/deutschland/baden-w%C3%BCrttemberg'] },
      { name: 'Bayern', key: ['/orte/deutschland/bayern'] },
      { name: 'Berlin', key: ['/orte/deutschland/berlin/berlin'] },
      { name: 'Brandenburg', key: ['/orte/deutschland/brandenburg'] },
      { name: 'Bremen', key: ['/orte/deutschland/bremen'] },
      { name: 'Hamburg', key: ['/orte/deutschland/hamburg/hamburg'] },
      { name: 'Hessen', key: ['/orte/deutschland/hessen'] },
      { name: 'Mecklenburg-Vorpommern', key: ['/orte/deutschland/mecklenburg-vorpommern'] },
      { name: 'Niedersachsen', key: ['/orte/deutschland/niedersachsen'] },
      { name: 'Nordrhein-Westfalen', key: ['/orte/deutschland/nordrhein-westfalen'] },
      { name: 'Rheinland-Pfalz', key: ['/orte/deutschland/rheinland-pfalz'] },
      { name: 'Saarland', key: ['/orte/deutschland/saarland'] },
      { name: 'Sachsen', key: ['/orte/deutschland/sachsen'] },
      { name: 'Sachsen-Anhalt', key: ['/orte/deutschland/sachsen-anhalt'] },
      { name: 'Schleswig-Holstein', key: ['/orte/deutschland/schleswig-holstein'] },
      { name: 'Thüringen', key: ['/orte/deutschland/th%C3%BCringen'] },
    ];

    return (
      <div className="oldHomepage">
        <div id="indexpage" className="grid property-page">
          <div className="grid">
            <SearchHeader />
            <div className="page-wrapper viewport">
              <InfoBoxes />
              <GeoElementsList headline="Deutschland" items={regions} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  screenResize: (width) => actions.screenResize(width),
  scrollY: (y) => actions.scrollY(y),
};

export default connect((state) => state, mapDispatchToProps)(App);
